module.exports = __webpack_public_path__ + "static/img/V_Hex.352e19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Desktop/Home_Landing/V_Hex.png
// module id = 2Dck
// module chunks = 0